export default __webpack_public_path__ + "static/media/Cootie (175).79edc458.jpg";